module.exports = __webpack_public_path__ + "img/google_play@2x.a7120a9b.png";